import axios from 'axios'

export interface LoginSubmitData {
  email: string
  password: string
  rememberMe?: boolean
}

export interface ConfirmRegistrationData {
  plainPassword: string
  firstName: string
  lastName: string
  token: string
}

export interface ResetPasswordData {
  token: string | null
  password: string
}

export interface ResetRequestData {
  email: string
}

export interface TwoFactorAuthData {
  _auth_code: string
  _trusted: boolean
}

export type MemberSubmitData =
  | LoginSubmitData
  | ConfirmRegistrationData
  | ResetPasswordData
  | ResetRequestData
  | TwoFactorAuthData

export const sendForm = (apiUrl: string, values: MemberSubmitData) =>
  axios.post(apiUrl, values, {
    headers: {
      'content-type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
